import React, {
  ReactElement,
} from 'react';

import {Box, Container, IconButton} from '@mui/material';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import {Navigation, Autoplay} from 'swiper/modules';
import 'swiper/css/autoplay';
import SwiperCore from 'swiper';
import {ChevronLeft, ChevronRight} from '@mui/icons-material';

SwiperCore.use([Navigation, Autoplay]);


export const ImageSlider = ({
                              images
                            }: {
  images: any;
}): ReactElement => {

  console.log(images);

  return (
    <Box py={5} sx={{ position: 'relative'}}>

      {/* Nyilak */}
      <IconButton
        className="swiper-button-prev"
        sx={{
          position: 'absolute',
          top: '50%',
          left: 10,
          zIndex: 2,
          transform: 'translateY(-50%)',
          backgroundColor: 'white',
          boxShadow: 1,
          '&:hover': {backgroundColor: 'grey.100'}
        }}
      >
        <ChevronLeft/>
      </IconButton>

      <IconButton
        className="swiper-button-next"
        sx={{
          position: 'absolute',
          top: '50%',
          right: 10,
          zIndex: 2,
          transform: 'translateY(-50%)',
          backgroundColor: 'white',
          boxShadow: 1,
          '&:hover': {backgroundColor: 'grey.100'}
        }}
      >
        <ChevronRight/>
      </IconButton>

      <Swiper
        spaceBetween={30}
        slidesPerView={3}
        loop={true}
        autoplay={{delay: 3000}}
        navigation={{nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'}}
        breakpoints={{
          320: {slidesPerView: 1},
          600: {slidesPerView: 1},
          960: {slidesPerView: 2},
          1280: {slidesPerView: 2},
          1680: {slidesPerView: 3},
          1920: {slidesPerView: 3},
        }}
      >
        {images.map((logo: any, idx: any) => (
          <SwiperSlide key={idx}>
            <Box
              component="img"
              src={logo?.link}
              alt={`Brand ${idx}`}
              sx={{
                width: '100%',
                height: '400px',
                maxHeight: '400px',
                '@media (max-width:600px)': {
                  maxHeight: '200px',
                },
                objectFit: 'contain',
                mx: 'auto',
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>

    </Box>
  );
};
